/** Strings for the data components (Pagination, Table, RunTrace). */
export const paginationCopy = {
  label: 'Pagination',
  previous: 'Previous page',
  next: 'Next page',
  loadMore: 'Load more',
  pageSize: 'Rows per page',
  range: (start: string, end: string, total: string) =>
    `${start}–${end} of ${total}`,
  loaded: (count: string) => `${count} loaded`,
} as const
export const tableCopy = {
  selectAll: 'Select all rows',
  sorted: (column: string, direction: 'ascending' | 'descending') =>
    `Sorted by ${column}, ${direction}`,
} as const
export const runTraceCopy = {
  counts: (llm: number, tools: number, duration: string) =>
    `${llm} llm · ${tools} tools · ${duration}`,
  kind: { llm: 'LLM call', tool: 'Tool call', nudged: 'Cycle nudged' },
  tokens: (input: string, output: string) => `${input} in / ${output} out`,
  ok: 'ok',
  failed: 'failed',
  response: 'response',
  toolCalls: 'tool calls',
  prompt: 'Assembled prompt',
  args: 'args',
  result: 'result',
  error: 'error',
  lastError: 'last error',
  nudgedAfter: (attempts: number) => `After ${attempts} identical failures`,
  noSteps: 'No steps captured for this run.',
  finished: (status: string) => `Run finished: ${status}`,
  retry: 'Retry',
} as const
